import React, { useRef, useState, useCallback } from 'react';
import './Ripple.css';

export default function RippleButton({
  children,
  onClick,
  className = '',
  variant = 'primary',
  disabled = false,
  type = 'button',
  ...props
}) {
  const buttonRef = useRef(null);
  const [ripples, setRipples] = useState([]);

  const createRipple = useCallback(
    (event) => {
      if (disabled) return;

      const button = buttonRef.current;
      if (!button) return;

      const rect = button.getBoundingClientRect();
      const size = Math.max(rect.width, rect.height);
      const x = event.clientX - rect.left - size / 2;
      const y = event.clientY - rect.top - size / 2;

      const newRipple = {
        id: Date.now(),
        x,
        y,
        size
      };

      setRipples((prev) => [...prev, newRipple]);

      setTimeout(() => {
        setRipples((prev) => prev.filter((r) => r.id !== newRipple.id));
      }, 600);

      if (onClick) {
        onClick(event);
      }
    },
    [disabled, onClick]
  );

  return (
    <button
      ref={buttonRef}
      className={`ripple-button ripple-button-${variant} ${className}`}
      onClick={createRipple}
      disabled={disabled}
      type={type}
      {...props}
    >
      {ripples.map((ripple) => (
        <span
          key={ripple.id}
          className="ripple-effect"
          style={{
            top: ripple.y,
            left: ripple.x,
            width: ripple.size,
            height: ripple.size
          }}
        />
      ))}
      <span className="ripple-button-content">{children}</span>
    </button>
  );
}
